import { createFileRoute, redirect } from '@tanstack/react-router'
import { CouponsListPage } from '@/pages/Coupons/CouponsListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/coupons')({
  component: CouponsListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/coupons')) {
      throw redirect({ to: '/' })
    }
  },
})
